export default "__VITE_ASSET__0e9511f8__"